<template>
  <div>
    <div class="row">
      <div class="col-md-12 col-lg-12">
        <KTCodePreview v-bind:title="'Clientes Cadastrados'">
          <template v-slot:preview>
            <div col-md-2 col-lg-2>
              <v-btn color="primary" fab small dark @click="novoCliente"
                ><v-icon>mdi-plus</v-icon></v-btn
              >
            </div>
            <br />
            <table class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Representante</th>
                  <th>Nome</th>
                  <th>CPF/CNPJ</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="cli in clientes" :key="cli.id">
                  <td>{{ cli.id }}</td>
                  <td>{{ cli.representante.nome }}</td>
                  <td>{{ cli.nome }}</td>
                  <td>{{ cli.cpfcnpj }}</td>
                  <td align="center">
                    <v-btn
                      color="warning"
                      fab
                      x-small
                      dark
                      @click="editar(cli.id)"
                      ><v-icon>mdi-pencil</v-icon></v-btn
                    >&nbsp;
                    <v-btn
                      color="error"
                      fab
                      x-small
                      dark
                      @click="inativar(cli.id)"
                      ><v-icon>mdi-trash-can</v-icon></v-btn
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </template>
        </KTCodePreview>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";
import KTCodePreview from "@/views/partials/content/CodePreview.vue";
import ApiService from "@/common/services/http/api.service";
import Swal from "sweetalert2";
import SweetAlert from "@/common/services/sweetalert.service";

export default {
  name: "cliente",
  data() {
    return {
      clientes: [],
    };
  },
  components: {
    KTCodePreview,
  },
  methods: {
    novoCliente() {
      this.$router.push({ name: "clienteCadastro" });
    },

    listaClientes() {
      return new Promise((resolve) => {
        ApiService.get("cliente").then(({ data }) => {
          if (data.success) {
            resolve(data);
            this.clientes = data.data;
          } else SweetAlert.sweetAlertError(data.errors);
        });
      });
    },

    editar(id) {
      this.$router.push({ path: "cliente/cadastro/" + id });
    },

    inativar(id) {
      let self = this;

      Swal.fire({
        title: "Tem certeza que deseja excluir esse registro?",
        text: "Essa operação não poderá ser desfeita!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim, pode excluir!",
      }).then(function (result) {
        if (result.value) {
          return new Promise((resolve) => {
            ApiService.put("cliente/" + id + "/inativar").then(({ data }) => {
              resolve(data);
              if (data.success === true) {
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Cliente Inativado com Sucesso!",
                  showConfirmButton: false,
                  timer: 1500,
                }).then(function () {
                  self.listaClientes();
                });
              } else SweetAlert.sweetAlertError(data.errors);
            });
          });
        }
      });
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Clientes" }]);
    this.listaClientes();
  },
};
</script>
